import { Property, TimePeriod } from '../types';

export const formatCurrency = (amount: number, currency: string = 'USD'): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatNumber = (num: number): string => {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
};

export const calculateCapRate = (property: Property): number => {
  const annualRent = property.monthly_rent * 12;
  const netOperatingIncome = annualRent - property.annual_taxes - property.annual_expenses;
  return (netOperatingIncome / property.current_value) * 100;
};

export const calculateROI = (property: Property): number => {
  const annualRent = property.monthly_rent * 12;
  const netOperatingIncome = annualRent - property.annual_taxes - property.annual_expenses;
  const appreciation = property.current_value - property.purchase_price;
  const totalReturn = netOperatingIncome + appreciation;
  return (totalReturn / property.purchase_price) * 100;
};

export const getTimePeriodLabel = (period: TimePeriod): string => {
  switch (period) {
    case 'hour':
      return 'Hour';
    case 'day':
      return 'Day';
    case 'week':
      return 'Week';
    case 'month':
      return 'Month';
    default:
      return 'Day';
  }
};

export const getTimePeriodOptions = (): { value: TimePeriod; label: string }[] => [
  { value: 'hour', label: 'Hour' },
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
];

export const cn = (...classes: (string | undefined | null | false)[]): string => {
  return classes.filter(Boolean).join(' ');
};

// Mock API to fetch current market value for a property by address
export async function fetchPropertyMarketValue(address: string, currentValue: number): Promise<number> {
  // TODO: Replace this mock with a real API call to a property valuation service (e.g., Zillow, Redfin, ATTOM)
  return new Promise((resolve) => {
    setTimeout(() => {
      // Simulate a market fluctuation of +/- 5%
      const fluctuation = 1 + (Math.random() * 0.1 - 0.05);
      resolve(Math.round(currentValue * fluctuation));
    }, 800); // Simulate network delay
  });
}

// Calculate dividend yield
export const calculateDividendYield = (annualDividendIncome: number, portfolioValue: number): number => {
  if (portfolioValue === 0) return 0;
  return annualDividendIncome / portfolioValue;
}; 